@file:OptIn(InternalResourceApi::class)

package top.features.user_management.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/top.features.user_management.generated.resources/"

@delegate:ResourceContentHash(1_960_898_230)
internal val Res.string.action_block_user: StringResource by lazy {
      StringResource("string:action_block_user", "action_block_user", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 57),
      ))
    }

@delegate:ResourceContentHash(1_161_262_213)
internal val Res.string.action_edit_profile: StringResource by lazy {
      StringResource("string:action_edit_profile", "action_edit_profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68, 75),
      ))
    }

@delegate:ResourceContentHash(1_360_745_331)
internal val Res.string.action_unblock_user: StringResource by lazy {
      StringResource("string:action_unblock_user", "action_unblock_user", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144, 59),
      ))
    }

@delegate:ResourceContentHash(-1_324_368_174)
internal val Res.string.btn_add_employee: StringResource by lazy {
      StringResource("string:btn_add_employee", "btn_add_employee", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204, 68),
      ))
    }

@delegate:ResourceContentHash(-46_467_519)
internal val Res.string.btn_add_moderator: StringResource by lazy {
      StringResource("string:btn_add_moderator", "btn_add_moderator", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273, 69),
      ))
    }

@delegate:ResourceContentHash(-624_430_713)
internal val Res.string.cd_actions_menu: StringResource by lazy {
      StringResource("string:cd_actions_menu", "cd_actions_menu", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343, 43),
      ))
    }

@delegate:ResourceContentHash(865_411_735)
internal val Res.string.empty_moderators_desc: StringResource by lazy {
      StringResource("string:empty_moderators_desc", "empty_moderators_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 387, 153),
      ))
    }

@delegate:ResourceContentHash(-1_508_601_887)
internal val Res.string.empty_moderators_title: StringResource by lazy {
      StringResource("string:empty_moderators_title", "empty_moderators_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 541, 130),
      ))
    }

@delegate:ResourceContentHash(-578_802_525)
internal val Res.string.empty_team_desc: StringResource by lazy {
      StringResource("string:empty_team_desc", "empty_team_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 672, 147),
      ))
    }

@delegate:ResourceContentHash(-577_223_062)
internal val Res.string.empty_team_title: StringResource by lazy {
      StringResource("string:empty_team_title", "empty_team_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 820, 124),
      ))
    }

@delegate:ResourceContentHash(-1_704_881_483)
internal val Res.string.empty_users_desc: StringResource by lazy {
      StringResource("string:empty_users_desc", "empty_users_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 945, 88),
      ))
    }

@delegate:ResourceContentHash(1_907_821_538)
internal val Res.string.empty_users_title: StringResource by lazy {
      StringResource("string:empty_users_title", "empty_users_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1034, 105),
      ))
    }

@delegate:ResourceContentHash(1_261_024_173)
internal val Res.string.filter_all: StringResource by lazy {
      StringResource("string:filter_all", "filter_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1140, 26),
      ))
    }

@delegate:ResourceContentHash(755_564_802)
internal val Res.string.filter_role_label: StringResource by lazy {
      StringResource("string:filter_role_label", "filter_role_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1167, 37),
      ))
    }

@delegate:ResourceContentHash(-1_944_461_382)
internal val Res.string.filter_status_label: StringResource by lazy {
      StringResource("string:filter_status_label", "filter_status_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1205, 47),
      ))
    }

@delegate:ResourceContentHash(-1_071_301_210)
internal val Res.string.modal_create_moderator_title: StringResource by lazy {
      StringResource("string:modal_create_moderator_title", "modal_create_moderator_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1253, 88),
      ))
    }

@delegate:ResourceContentHash(1_657_965)
internal val Res.string.placeholder_dash: StringResource by lazy {
      StringResource("string:placeholder_dash", "placeholder_dash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1342, 28),
      ))
    }

@delegate:ResourceContentHash(438_629_848)
internal val Res.string.role_business_owner: StringResource by lazy {
      StringResource("string:role_business_owner", "role_business_owner", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1371, 67),
      ))
    }

@delegate:ResourceContentHash(-957_839_042)
internal val Res.string.role_client: StringResource by lazy {
      StringResource("string:role_client", "role_client", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1439, 35),
      ))
    }

@delegate:ResourceContentHash(-448_659_307)
internal val Res.string.role_employee: StringResource by lazy {
      StringResource("string:role_employee", "role_employee", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1475, 45),
      ))
    }

@delegate:ResourceContentHash(785_212_283)
internal val Res.string.search_placeholder: StringResource by lazy {
      StringResource("string:search_placeholder", "search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1521, 114),
      ))
    }

@delegate:ResourceContentHash(-697_482_885)
internal val Res.string.status_active: StringResource by lazy {
      StringResource("string:status_active", "status_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1636, 45),
      ))
    }

@delegate:ResourceContentHash(-71_704_435)
internal val Res.string.status_blocked: StringResource by lazy {
      StringResource("string:status_blocked", "status_blocked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1682, 54),
      ))
    }

@delegate:ResourceContentHash(536_555_200)
internal val Res.string.status_deactivated: StringResource by lazy {
      StringResource("string:status_deactivated", "status_deactivated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1737, 62),
      ))
    }

@delegate:ResourceContentHash(-1_988_332_612)
internal val Res.string.status_unauthorized: StringResource by lazy {
      StringResource("string:status_unauthorized", "status_unauthorized", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1800, 71),
      ))
    }

@delegate:ResourceContentHash(-550_419_753)
internal val Res.string.status_unknown: StringResource by lazy {
      StringResource("string:status_unknown", "status_unknown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1872, 46),
      ))
    }

@delegate:ResourceContentHash(1_490_221_713)
internal val Res.string.table_col_actions: StringResource by lazy {
      StringResource("string:table_col_actions", "table_col_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1919, 33),
      ))
    }

@delegate:ResourceContentHash(212_640_680)
internal val Res.string.table_col_date: StringResource by lazy {
      StringResource("string:table_col_date", "table_col_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1953, 62),
      ))
    }

@delegate:ResourceContentHash(859_675_006)
internal val Res.string.table_col_email: StringResource by lazy {
      StringResource("string:table_col_email", "table_col_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2016, 67),
      ))
    }

@delegate:ResourceContentHash(1_500_748_047)
internal val Res.string.table_col_name: StringResource by lazy {
      StringResource("string:table_col_name", "table_col_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2084, 58),
      ))
    }

@delegate:ResourceContentHash(1_962_512_428)
internal val Res.string.table_col_phone: StringResource by lazy {
      StringResource("string:table_col_phone", "table_col_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2143, 59),
      ))
    }

@delegate:ResourceContentHash(-841_510_675)
internal val Res.string.table_col_requests: StringResource by lazy {
      StringResource("string:table_col_requests", "table_col_requests", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2203, 66),
      ))
    }

@delegate:ResourceContentHash(1_522_781_474)
internal val Res.string.table_col_status: StringResource by lazy {
      StringResource("string:table_col_status", "table_col_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2270, 40),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("action_block_user", Res.string.action_block_user)
  map.put("action_edit_profile", Res.string.action_edit_profile)
  map.put("action_unblock_user", Res.string.action_unblock_user)
  map.put("btn_add_employee", Res.string.btn_add_employee)
  map.put("btn_add_moderator", Res.string.btn_add_moderator)
  map.put("cd_actions_menu", Res.string.cd_actions_menu)
  map.put("empty_moderators_desc", Res.string.empty_moderators_desc)
  map.put("empty_moderators_title", Res.string.empty_moderators_title)
  map.put("empty_team_desc", Res.string.empty_team_desc)
  map.put("empty_team_title", Res.string.empty_team_title)
  map.put("empty_users_desc", Res.string.empty_users_desc)
  map.put("empty_users_title", Res.string.empty_users_title)
  map.put("filter_all", Res.string.filter_all)
  map.put("filter_role_label", Res.string.filter_role_label)
  map.put("filter_status_label", Res.string.filter_status_label)
  map.put("modal_create_moderator_title", Res.string.modal_create_moderator_title)
  map.put("placeholder_dash", Res.string.placeholder_dash)
  map.put("role_business_owner", Res.string.role_business_owner)
  map.put("role_client", Res.string.role_client)
  map.put("role_employee", Res.string.role_employee)
  map.put("search_placeholder", Res.string.search_placeholder)
  map.put("status_active", Res.string.status_active)
  map.put("status_blocked", Res.string.status_blocked)
  map.put("status_deactivated", Res.string.status_deactivated)
  map.put("status_unauthorized", Res.string.status_unauthorized)
  map.put("status_unknown", Res.string.status_unknown)
  map.put("table_col_actions", Res.string.table_col_actions)
  map.put("table_col_date", Res.string.table_col_date)
  map.put("table_col_email", Res.string.table_col_email)
  map.put("table_col_name", Res.string.table_col_name)
  map.put("table_col_phone", Res.string.table_col_phone)
  map.put("table_col_requests", Res.string.table_col_requests)
  map.put("table_col_status", Res.string.table_col_status)
}
